import { cur } from '@/lib/currency';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Building2 } from 'lucide-react';

export function BranchSummaryTab({ branchSummary }) {
  return (
    <div className="space-y-4">
      {branchSummary.map(branch => (
        <Card key={branch.branch_id}>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Building2 size={18} className="text-info" />
                <span className="font-outfit">{branch.branch_name}</span>
              </div>
              <div className="flex gap-4 text-sm">
                <span className="text-purple-600">Sales: {cur()} {branch.totals.total_sales.toLocaleString()}</span>
                <span className="text-success">Received: {cur()} {branch.totals.total_received.toLocaleString()}</span>
                <Badge variant={branch.totals.total_pending > 0 ? 'destructive' : 'secondary'}>
                  Pending: {cur()} {branch.totals.total_pending.toLocaleString()}
                </Badge>
              </div>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left p-2">Platform</th>
                    <th className="text-right p-2">Commission %</th>
                    <th className="text-right p-2">Sales</th>
                    <th className="text-right p-2">Commission</th>
                    <th className="text-right p-2">Received</th>
                    <th className="text-right p-2">Pending</th>
                  </tr>
                </thead>
                <tbody>
                  {branch.platforms.map((p, idx) => (
                    <tr key={idx} className="border-t">
                      <td className="p-2 font-medium">{p.platform_name}</td>
                      <td className="p-2 text-right text-muted-foreground">{p.commission_rate}%</td>
                      <td className="p-2 text-right text-purple-600">{cur()} {p.sales.toLocaleString()}</td>
                      <td className="p-2 text-right text-warning">{cur()} {p.commission.toLocaleString()}</td>
                      <td className="p-2 text-right text-success">{cur()} {p.received.toLocaleString()}</td>
                      <td className="p-2 text-right font-bold text-error">
                        {p.pending > 0 ? `${cur()} ${p.pending.toLocaleString()}` : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      ))}
      {branchSummary.length === 0 && (
        <Card>
          <CardContent className="py-8 text-center text-muted-foreground">
            <Building2 size={48} className="mx-auto mb-3 opacity-30" />
            <p>No branch platform sales yet. Record online sales with a branch to see breakdown.</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
